import CommercialRulesFormContainer from './CommercialRulesFormContainer'

export default function CommercialRulesFormScreen() {
    return <CommercialRulesFormContainer />
}
